const NON_PRINTABLE = [
  ' ',
  '\n', // LINE FEED
  '\r', // CARRIAGE RETURN
  '\t', // TABULATION
  '\v', // LINE TABULATION
  '\f', // FORM FEED
  '\u200B', // ZERO WIDTH SPACE
  '\u200C', // ZERO WIDTH NON-JOINER
  '\u200D', // ZERO WIDTH JOINER
  '\uFEFF', // ZERO WIDTH NO-BREAK SPACE
  '\u00A0', // NO-BREAK SPACE
  '\u2060', // WORD JOINER
  '\u180E', // MONGOLIAN VOWEL SEPARATOR
  '\u2028', // LINE SEPARATOR
  '\u2029', // PARAGRAPH SEPARATOR
  '\u0000', // NUL BYTE
]

export const isPrintable = <T = unknown>(
  it: T,
): it is NonNullable<T> & string => {
  if (typeof it !== 'string') return false

  for (const char of it) {
    if (!NON_PRINTABLE.includes(char)) return true
  }
  return false
}
